/**
 * 사업자 → 멍투데이 크레딧 결제 (PG 충전) 조회 훅.
 *  usePayments 와 동일 패턴, 다른 엔드포인트.
 */

import { useQuery } from '@tanstack/react-query';
import { paymentsApi } from '../services/api/payments';
import type { CreditPaymentFilters } from '../types/payment';
import { useState } from 'react';

function getTodayInputValue(): string {
  const d = new Date();
  const yyyy = d.getFullYear();
  const mm = String(d.getMonth() + 1).padStart(2, '0');
  const dd = String(d.getDate()).padStart(2, '0');
  return `${yyyy}-${mm}-${dd}`;
}

export function useCreditPayments(initialPage = 1, initialSize = 10) {
  const [page, setPage] = useState(initialPage);
  const [size, setSize] = useState(initialSize);
  const todayStr = getTodayInputValue();
  const [filters, setFilters] = useState<CreditPaymentFilters>({
    paymentStatus: 'ALL',
    paymentMethod: 'ALL',
    startDate: todayStr,
    endDate: todayStr,
    sortBy: 'dtPaid',
    sortOrder: 'DESC',
  });

  const { data, isLoading, isFetching, error, refetch } = useQuery({
    queryKey: ['credit-payments', page, size, filters],
    queryFn: () => paymentsApi.getCreditPayments(page, size, filters),
    placeholderData: (prev) => prev,
    staleTime: 30 * 1000,
    gcTime: 5 * 60 * 1000,
  });

  return {
    payments: data?.content || [],
    pagination: data?.pagination,
    statistics: data?.statistics,
    isLoading,
    isFetching,
    error,
    page,
    size,
    setPage,
    setSize,
    filters,
    setFilters,
    refetch,
  };
}
